/**
 * @Description 客流转化漏斗
 */

import { FC } from 'react';
// import cs from 'classnames';
import styles from './index.module.less';

/**
 * @Description 客流转化漏斗单条数据
 */
export interface TrafficConversionFunnelItem {
  /** 唯一标识，用作列表 key */
  key: string;
  /** 主标签，如「5分钟步行圈居住人口」 */
  label: string;
  /** 副标签，如「常住人口 8,320人 | 工作人口 4,165人」 */
  subLabel?: string;
  /** 右侧展示数值，不含单位 */
  value: string;
  /** 右侧数值单位，如「人」「人/天」 */
  unit?: string;
  /** 漏斗条宽度（百分比字符串，逐级收缩形成漏斗形状） */
  width: string;
  /** 漏斗条背景色 */
  color: string;
}

interface TrafficConversionFunnelProps {
  /** 漏斗数据，由父组件从客群漏斗接口拼装后传入 */
  data: TrafficConversionFunnelItem[];
};

/**
 * @Description 客流转化漏斗
 */
const TrafficConversionFunnel: FC<TrafficConversionFunnelProps> = ({ data }) => {

  return (
    <div className={styles.trafficFunnel}>
      {data.map((item) => (
        <div
          className={styles.trafficFunnelRow}
          key={item.key}
          style={{ width: item.width, background: item.color }}
        >
          <div className={styles.trafficFunnelLabel}>
            <div className={styles.trafficFunnelLabelText}>{item.label}</div>
            {item.subLabel && <div className={styles.trafficFunnelSubLabel}>{item.subLabel}</div>}
          </div>
          <div className={styles.trafficFunnelValue}>
            {item.value}
            {item.unit && <span className={styles.trafficFunnelValueUnit}>{item.unit}</span>}
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrafficConversionFunnel;
